import { createQuery } from '../common';
import { getUserInfo } from '../apis';

export const QUERY_KEY_USER_INFO = `/gm/user-info` as const;

export const useUserInfo = createQuery({
  queryKey: [QUERY_KEY_USER_INFO],
  queryFn: getUserInfo,
  cacheTime: Infinity,
  staleTime: Infinity,
});
